import React from 'react';
import { useTranslation } from 'react-i18next';
import { Trash2, X } from 'react-native-feather';
import { AlertHandle, Headline, HoverButton, Row } from 'src/components';
import { Size } from 'src/constants';
import useGoBack from 'src/hooks/useGoBack';
import { useAppTheme } from 'src/providers/AppThemeProvider';
import styled from 'styled-components/native';

interface Props {
  id?: number;
  alertHandle: React.RefObject<AlertHandle>;
}

const Header = ({ id, alertHandle }: Props) => {
  const { t } = useTranslation('todos');
  const { colors } = useAppTheme();
  const goBack = useGoBack();
  return (
    <StyledRow>
      <StyledPressable onPress={() => goBack()}>
        <X width={Size.L} color={colors.onSurface} />
      </StyledPressable>
      <Headline color={colors.onSurface}>
        {t(id ? 'createTodo.titleEdit' : 'createTodo.titleCreate')}
      </Headline>
      {id && (
        <NoPaddingHoverButton onPress={alertHandle.current?.alert}>
          <Trash2 color={colors.onSurface} />
        </NoPaddingHoverButton>
      )}
    </StyledRow>
  );
};

export default Header;

const StyledRow = styled(Row)`
  margin-horizontal: ${Size.M}px;
`;

const StyledPressable = styled.Pressable`
  position: absolute;
  left: 0;
`;

const NoPaddingHoverButton = styled(HoverButton)`
  padding: 0;
  position: absolute;
  right: 0;
`;
